import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import "./utils/request";
import "@/utils/directive";
import "@/utils/fn";
import "@/utils/permission"; // permission control
import '@/assets/css/fonts.css' 
// import Vconsole from 'vconsole';
// export default new Vconsole();
import toast from "./components/toast/index";
Vue.use(toast);

import "lib-flexible";

Vue.config.productionTip = false;

Vue.prototype.$axios = axios;

import {
  NavBar,
  Button,
  Image as VanImage,
  Lazyload,
  Tabbar,
  TabbarItem,
  Dialog,
  Empty,
  Loading,
} from "vant";


Vue.use(Button);
Vue.use(NavBar);
Vue.use(VanImage);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Dialog);
Vue.use(Empty);
Vue.use(Loading);

// 注册时可以配置额外的选项
Vue.use(Lazyload, {
  lazyComponent: true,
  attempt: 2,
  loading: require("./assets/icon/loading.gif"),
  error: require("./assets/icon/img-error.png"),
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
